<div class="search-autocomplete-container">
  <div class="row align-items-center flex-nowrap">
    <div class="col-auto mt-2">
      <mat-button-toggle-group
        [value]="activeSearchModeIdx"
        name="searchMode"
        aria-label="Modalità di ricerca"
        (change)="onChangeSearchMode($event)"
      >
        <mat-button-toggle
          [value]="i"
          *ngFor="let mode of searchModes; let i = index"
          [aria-label]="mode.tooltipLabel"
          [matTooltip]="mode.tooltipLabel"
        >
          <div
            class="toggle-btn-content"
            [ngStyle]="{
              'background-image': 'url(data:image/svg+xml;base64,' + mode.base64Icon + ')'
            }"
          ></div>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="col-auto">
      <!-- GOOGLE -->
      <mat-form-field
        class="google-search-input"
        *ngIf="isGoogleKeyEnabled"
        [hidden]="searchModes[activeSearchModeIdx].action !== DEFAULT_ACTION"
      >
        <mat-label class="font-09rem">{{
          (isGoogleKeyEnabled ? 'map.control_search.search_addresses_and_poi' : 'map.control_search.search_coordinates')
            | translate
        }}</mat-label>
        <input
          [ngModel]="inputDefaultVal"
          matInput
          type="text"
          (ngModelChange)="defaultInputChange($event)"
          #MapsAutocomplete
        />
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearDefaultSearchVal()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- OTHER -->
      <mat-form-field class="map-search-input"
        [hidden]="searchModes[activeSearchModeIdx].action === DEFAULT_ACTION"
        [style.width]="inputVal ? inputValLength * 10 : 1">
        <mat-label class="font-09rem">{{ searchModes[activeSearchModeIdx].label }}</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="inputVal"
          (ngModelChange)="onSearchInputChange($event)"
          [matAutocomplete]="inputAutoComplete"
          [readonly]="isLoading"
        />
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearAutoComplete()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          class="map-searchbar"
          #inputAutoComplete="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onAutocompleteSelectionChanged($event)"
          panelWidth="50vw"
        >
          <mat-option *ngFor="let option of autoCompletefilteredOptions; let i = index"
            [value]="option"
            [disabled]="!option.desc"
            [ngClass]="{ 'bg-gray': i % 2 === 0 }">
            <span
              *ngIf="!option.desc"
              class="d-block center"
              [matTooltip]="'map.search.more_description' | translate"
              matTooltipPosition="right"
              matTooltipClass="info-button-tooltip"
            >
              {{ 'map.search.more' | translate }}
            </span>

            <span
              *ngIf="option.desc"
              class="d-block"
              [matTooltip]="option.desc"
              matTooltipPosition="right"
              matTooltipClass="info-button-tooltip"
              >{{ option.desc }}
            </span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-auto" *ngIf="currentFeatureResponse">
      <button mat-icon-button class="change-search-mode-btn" (click)="showFeaturePopup()">
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
